import { render, staticRenderFns } from "./hierarchy-form.vue?vue&type=template&id=47cbdd9f&scoped=true&"
import script from "./hierarchy-form.ts?vue&type=script&lang=ts&"
export * from "./hierarchy-form.ts?vue&type=script&lang=ts&"
import style0 from "./hierarchy-form.scss?vue&type=style&index=0&id=47cbdd9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbdd9f",
  null
  
)

export default component.exports